import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { ReportsEffects } from './effects/reports.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('reportState', reducers),
    EffectsModule.forFeature([
      ReportsEffects
    ])
  ]
})
export class ReportsStoreModule {}
